/**
 * @fileoverview Workspace Pre-Appointment Labels
 *
 * URL: /dashboard/pre-appointment-labels
 *
 * Firm-defined tags applied to pre-appointment jobs for filtering and
 * grouping. Lives under the workspace Pre-Appointment section in the sidebar.
 * Admin/owner can create, edit, recolour and reorder; system labels are
 * protected from deletion.
 *
 * - Convex: preAppointment.labels.*
 */
import { createFileRoute } from "@tanstack/react-router";
import type { Id } from "@cvx/_generated/dataModel";
import { useActiveOrg } from "@/utils/org-context";
import { PreAppointmentLabelsManager } from "@/components/settings/pre-appointment/PreAppointmentLabelsManager";

export const Route = createFileRoute(
  "/_app/_auth/dashboard/_layout/pre-appointment-labels",
)({
  component: PreAppointmentLabelsPage,
});

function PreAppointmentLabelsPage() {
  const { orgId, activeOrg } = useActiveOrg();
  const canEdit = activeOrg?.role === "owner" || activeOrg?.role === "admin";

  return (
    <div className="flex flex-1 flex-col gap-5 bg-muted p-6">
      {orgId ? (
        <PreAppointmentLabelsManager
          orgId={orgId as Id<"organizations">}
          canEdit={canEdit}
        />
      ) : (
        <div className="text-sm text-muted-foreground">
          Select an organisation to manage pipeline labels.
        </div>
      )}
    </div>
  );
}
